export default __webpack_public_path__ + "static/media/stripe_icon.05cb23fa.svg";